import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingCheckoutSuccessMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.products
   * @param {String} param.data.products.id
   * @param {Number} param.data.products.price
   */
  map({page, culture, data}) {
    const {products} = data
    const trackingData = {
      currency: 'EUR',
      products: [
        {
          id: products?.id,
          category: 'visibility products',
          quantity: 1,
          price: products?.price
        }
      ],
      revenue: products?.price?.toString().replace('.', ',')
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
